import style from "./UserProfile.module.css";

import { useParams, Navigate } from "react-router-dom";

import ProfileBanner from "@/features/auth/components/profileBanner/ProfileBanner";
import ProfileConent from "@/features/auth/components/profileContent/ProfileContent";

import { useGetUserByUsername } from "@/features/auth/hooks/useGetUserByUsername";
import FullPageLoader from "@/ui/fullPageLoader/FullPageLoader";

function UserProfile() {
	const { username } = useParams();
	const { isPending, isError } = useGetUserByUsername(username);

	if (isPending) return <FullPageLoader />;
	if (isError) return <Navigate to="/404" />;

	return (
		<>
			<ProfileBanner username={username} />
			<ProfileConent username={username} />
		</>
	);
}

export default UserProfile;
